import { ToArray } from '@/utils'

export default key => ({
  get(rawValue = {}) {
    if (!('properties' in rawValue)) return []

    let target = ToArray(rawValue.properties).find(prop => prop.startsWith(key + ':'))
    if (!target) return []

    let [, value] = target.split(':')
    value = value.split(',')
    return value
  },
  set(value, data) {
    if (!value.length) return { properties: undefined }
    let others = ToArray(data.properties).filter(prop => !prop.startsWith(key + ':'))
    return { properties: [`${key}:${value.join(',')}`, ...others] }
  },
})
